<div id="main-container">
  <app-menu-bar></app-menu-bar>

  <div id="content-container">
    <notifier-container>notifier</notifier-container>
    <router-outlet></router-outlet>
  </div>

  <app-footer *ngIf="showBottomBanner" class="app-footer"></app-footer>
</div>
